// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BLOG_COMMENT_REMOVE_COMPLAINT = "Zru\u0161 nahl\u00e1\u0161en\u00ed koment\u00e1\u0159e";
export const COMMENT = "Koment\u00e1\u0159";
export const COMPLAINTS_REPORTED_BY = "nahl\u00e1sila";
export const IMAGE = "Obr\u00e1zek";
export const IMAGE_REMOVE_COMPLAINTS = "Zru\u0161 nahl\u00e1\u0161en\u00ed obr\u00e1zku";
export const POST_COMPLAINTS_SUBTREE = "Nahl\u00e1\u0161en\u00ed v sou\u010d\u00e1stech p\u0159\u00edspevku";
export const POST_REMOVE_COMPLAINTS_ALSO_POST_SUBTREE_COMPLAINTS = "Zru\u0161 nahl\u00e1\u0161en\u00ed p\u0159\u00edsp\u011bvku i nahl\u00e1\u0161en\u00ed sou\u010d\u00e1st\u00ed p\u0159\u00edsp\u011bvku";
export const POST_SUBTREE_REMOVE_COMPLAINTS = "Zru\u0161 nahl\u00e1\u0161en\u00ed sou\u010d\u00e1st\u00ed p\u0159\u00edsp\u011bvku";
